<app-blocks-workflow [blocks]="workflow.blocks" [models]="workflow.models" [context]="workflow.context"></app-blocks-workflow>
